export const simulationOverviewFixture = (campaignId) => ({
  id: Number(campaignId) || 27,
  available: true,
  phase: 'collecting',
  vector: 'dataEntry',
  fileFormat: null,
  delivered: 232,
  scheduled: 240,
  notDelivered: 8,
  opened: 168,
  counts: {
    submitted: 4,
    clicked: 12,
    reported: 46,
    opened: 106,
    none: 64,
  },
  recovered: 5,
  enrolled: {
    completed: 9,
    inProgress: 3,
    late: 0,
  },
  trainingModuleAttached: true,
  firstReportMin: 4,
  sendWindow: {
    days: 5,
    sentDays: 5,
    perDay: 48,
    start: '10 Aug',
    end: '14 Aug',
  },
})
